const basico1 = {
  titulo: `JavaScript: funciones setTimeout y setInterval`,
  problemas: [
    {
      codigo: 1,
      descripcion: `La programación asíncrona es una técnica de programación que permite ejecutar una actividad potencialmente larga en una función sin bloquear la ejecución de la función principal de la aplicación.
Muchas actividades en los navegadores, pueden llevar mucho tiempo y no es conveniente que la aplicación se bloquee. Por ejemplo, una aplicación web puede tener que recuperar datos de un servidor, y eso puede llevar mucho tiempo.
En JavaScript hay una serie de funciones y objetos que nos permiten ejecutar una actividad en segundo plano.
La primera es la función setTimeout(), que permite ejecutar una función en un tiempo determinado en el futuro.`,
      programa: `let contador = 1
setTimeout(() => contador++, 1000)
contador++
console.log(contador)`,
      solucion: "2"
    },{
      codigo: 2,
      descripcion: `En el ejemplo anterior el contador vale 2 cuando se ejecuta la cuarta línea de código. La función setTimeout() ejecuta la función flecha que le pasamos como parámetro en un tiempo determinado en el futuro (en nuestro ejemplo en 1000 milisegundos)`,
      programa: `let contador = 1
setTimeout(() => { 
  contador++
  console.log(contador)
} , 1000)
contador++`,
      solucion: "3"
    },{
      codigo: 3,
      descripcion: `Podemos hacer múltiples llamadas a setTimeout() para ejecutar una función en un tiempo determinado en el futuro.`,
      programa: `const arreglo = []
setTimeout(() => {
  arreglo.push(3)
  console.log(arreglo)
}, 1000)
setTimeout(() => {
  arreglo.push(2)
}, 500)
arreglo.push(1)`,
      solucion: "[1,2,3]"
    },{
      codigo: 4,
      descripcion: `Tambien podemos llamar a setTimeout() dentro de la funcion callback de otra funcion setTimeout()`,
      programa: `const arreglo = []
setTimeout(() => {
  arreglo.push(2)
  setTimeout(() => {
    arreglo.push(3)
    console.log(arreglo)
  }, 500)
}, 500)
arreglo.push(1)`,
      solucion: "[1,2,3]"
    },{
      codigo: 5,
      descripcion: `Si a la función setTimeout() le pasamos 0 como parámetro, la función se ejecuta también en forma asíncrona, es decir no se ejecuta inmediatamente. Si llamamos dos veces a setTimeout() con 0 como parámetro, la segunda función se ejecuta después de la primera siempre.`,
      programa: `const arreglo = []
setTimeout(() => {
  arreglo.push(2)
}, 0)
setTimeout(() => {
  arreglo.push(3)
  console.log(arreglo)
}, 0)
arreglo.push(1)`,
      solucion: "[1,2,3]"
    },{
      codigo: 6,
      descripcion: `JavaScript debe terminar todo el código síncrono antes de ejecutar cualquier código asíncrono. Por ejemplo veamos que sucede si nos detenemos 1 segundo en el hilo principal de la aplicación.
La detención la logramos con un while:
<pre>
function retornarHora() {
  return new Date().getTime()
}
const horaInicio = retornarHora()
while (retornarHora()<=horaInicio+1000){
  // no hacemos nada
}
</pre>`,
      programa: `function retornarHora() {
  return new Date().getTime()
}
const horaInicio = retornarHora()
const arreglo = []
setTimeout(() => {
  arreglo.push(2)
}, 0)
setTimeout(() => {
  arreglo.push(3)
  console.log(arreglo)
}, 0)
arreglo.push(1)
while (retornarHora()<=horaInicio+1000){
  // no hacemos nada
}`,
      solucion: "[1,2,3]"
    },{
      codigo: 7,
      descripcion: `Otra función que nos permite ejecutar un algoritmo en forma asíncrona es setInterval(), que permite ejecutar una función cada cierto tiempo.
La diferencia entre setInterval() y setTimeout() es que setInterval() ejecuta la función cada cierto tiempo, mientras que setTimeout() ejecuta la función una sola vez.
La función setInterval() retorna un identificador que podemos usar para detener la ejecución de la función.`,
      programa: `const arreglo = []
let cantidad = 0
const accion1 = setInterval(() => {
  cantidad++
  arreglo.push(cantidad)
  if (cantidad === 5) {
    clearInterval(accion1)
    console.log(arreglo)
  }
}, 200)
arreglo.push(cantidad)`,
      solucion: "[0,1,2,3,4,5]"
    },{
      codigo: 8,
      descripcion: `No dijimos antes, pero la función setTimeout() también podemos detener el algoritmo asíncrono antes que se ejecute.`,
      programa: `const accion1 = setTimeout(() => {
  console.log("Actividad asincrona")
}, 1000)
console.log("Actividad sincrona")
clearTimeout(accion1)`,
      solucion: "'Actividad sincrona'"
    },{
      codigo: 9,
      descripcion: ``,
      programa: `const arreglo1=[]

const intervalo1 = setInterval(() => arreglo1.push('oh'), 300)

setTimeout(() => {
  clearInterval(intervalo1)
  console.log(arreglo1)
}, 700)`,
      solucion: "['oh','oh']"
    },{
      codigo: 10,
      descripcion: `Si creamos un intervalo e inmediatamente lo detenemos, no se ejecutará nunca.`,
      programa: `const arreglo1 = []
const intervalo1 = setInterval(() => {
  array.push('oh')
  console.log(arreglo1)
}, 1)
clearInterval(intervalo1)
console.log('no se ejecuta intervalo')`,
      solucion: "'no se ejecuta intervalo'"
    }
  ]
}

export default basico1;